import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';

import MENU_ITEMS from '../../menu-items';
import NavItem from './NavItem';
import logoutUser from 'src/auth/use-cases/logoutUser';

const getUserInfo = () => {
  if (!localStorage.user) {
    return;
  }

  const user = JSON.parse(localStorage.user);

  return {
    avatar: '/static/images/avatars/avatar_default.svg',
    jobTitle: 'ADMINISTRADOR',
    name: `${user.firstname} ${user.surnames}`,
    scopes: user.scopes
  };
};

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [menuItems, setMenuItems] = useState([]);

  const setUserAvatarInfo = () => {
    const userInfo = getUserInfo();
    if (userInfo) {
      setUser(userInfo);
    }
  };

  const setMenuItemsByUserScopes = () => {
    if (user?.scopes) {
      const canShowMenuItem = (menuItem) => {
        return menuItem.scope.every((item) => {
          return user.scopes.includes(item);
        });
      };

      const filteredMenuItems = MENU_ITEMS.filter(canShowMenuItem);

      const hasPermission = filteredMenuItems.filter(
        (x) => location.pathname.indexOf(x.href) !== -1
      );
      if (!hasPermission.length) {
        logoutUser();
        navigate('/login', { replace: true });
        return;
      }

      setMenuItems(filteredMenuItems);
    }
  };

  useEffect(() => {
    if (!user || !Object.keys(user).length) {
      setUserAvatarInfo();
    }

    setMenuItemsByUserScopes();

    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname, user]);

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          <Box height="100%" display="flex" flexDirection="column">
            <Box
              alignItems="center"
              display="flex"
              flexDirection="column"
              p={2}
            >
              <Typography
                className={classes.name}
                color="textPrimary"
                variant="h5"
              >
                {user.name}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {user.jobTitle}
              </Typography>
            </Box>
            <Divider />
            <Box p={2}>
              <List>
                {menuItems.map((item) => (
                  <NavItem
                    href={item.href}
                    key={item.title}
                    title={item.title}
                    icon={item.icon}
                  />
                ))}
              </List>
            </Box>
            <Box flexGrow={1} />
          </Box>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          <Box height="100%" display="flex" flexDirection="column">
            <Box
              alignItems="center"
              display="flex"
              flexDirection="column"
              p={2}
            >
              <Avatar
                className={classes.avatar}
                component={RouterLink}
                src={user.avatar}
                to="/app/settings"
              />
              <Typography
                className={classes.name}
                color="textPrimary"
                variant="h5"
              >
                {user.name}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {user.jobTitle}
              </Typography>
            </Box>
            <Divider />
            <Box p={2}>
              <List>
                {menuItems.map((item) => (
                  <NavItem
                    href={item.href}
                    key={item.title}
                    title={item.title}
                    icon={item.icon}
                  />
                ))}
              </List>
            </Box>
            <Box flexGrow={1} />
          </Box>
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
